import React, { useEffect } from 'react';
import './css/Login.css';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux'
import { useForm } from 'react-hook-form'
import { userLogin } from '../features/auth/authAction'
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import Alert from '../helpers/alertBox'
import ErrorBoundary from '../helpers/errorBound'
import { Container, Box, Typography, Paper } from '@mui/material';

const AdminLogin = () => {
    const { loading, loggedUserInfo, error } = useSelector((state) => state.auth)

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { register, handleSubmit } = useForm();
    const [showPassword, setShowPassword] = React.useState(false);

    const handleClickShowPassword = () => setShowPassword((show) => !show);
    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    const submitLogin = async (data) => {
        const result = await dispatch(userLogin(data));
        if (userLogin.fulfilled.match(result)) {
            const role = result.payload.role;
            if (role === 'admin') {
                navigate('/dashboard-admin');
            } else {
                alert("Not authorized as admin"); // Simple alert for now
            }
        }
    }

    return (
        <Container component="main" maxWidth="xs" sx={{ height: '80vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <Paper elevation={3} sx={{ p: 4, width: '100%', borderRadius: 2 }}>
                <ErrorBoundary fallback={<p>Something went wrong</p>}>
                    <Alert />
                </ErrorBoundary>
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mb: 3 }}>
                    <Typography component="h1" variant="h5" sx={{ fontWeight: 'bold', color: 'primary.main' }}>
                        Admin Login
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        Authorized personnel only
                    </Typography>
                </Box>
                <form id='form' onSubmit={handleSubmit(submitLogin)} className="flex flex-col">
                    <FormControl sx={{ mb: 2, width: '100%' }} variant="outlined">
                        <InputLabel>Email Address</InputLabel>
                        <OutlinedInput
                            label="Email Address"
                            {...register('email')}
                        />
                    </FormControl>
                    <FormControl sx={{ mb: 3, width: '100%' }} variant="outlined">
                        <InputLabel htmlFor="outlined-adornment-password">Password</InputLabel>
                        <OutlinedInput
                            id="outlined-adornment-password"
                            type={showPassword ? 'text' : 'password'}
                            endAdornment={
                                <InputAdornment position="end">
                                    <IconButton
                                        aria-label="toggle password visibility"
                                        onClick={handleClickShowPassword}
                                        onMouseDown={handleMouseDownPassword}
                                        edge="end"
                                        size='small'
                                    >
                                        {showPassword ? <VisibilityOff /> : <Visibility />}
                                    </IconButton>
                                </InputAdornment>
                            }
                            label="Password"
                            {...register('password')}
                        />
                    </FormControl>
                    <button type="submit" className='btn btn-primary' disabled={loading} style={{ width: '100%', padding: '10px', backgroundColor: '#71123e', color: 'white', borderRadius: '5px', border: 'none', cursor: 'pointer' }}>
                        {loading ? 'Logging in...' : 'Login'}
                    </button>
                </form>
            </Paper>
        </Container>
    )
}
export default AdminLogin;
